import { DateTime } from 'luxon';

import { ServiceStatus } from '../../prtg-constants';

export class ServiceFlatNode
{
    depth: number;
    active: boolean;
    id: string;
    serviceId: string;
    identifier: string;
    type: string;
    priority: number;
    status: string;
    codeStatus: string;
    statusMessage: string;
    isAcknowledged: boolean;
    name: string;
    hostName: string;
    hostAddress: string;
    displayName: string;
    lastValue: string;
    typeService: string;
    kindService: string;
    lastUpdateTime?: DateTime;
    tags: string;
    parentIdentifier: string;
    parentName: string;
    metaStatus: string;
    flagStatus: ServiceStatus;
    cumulativeFlagStatus: number;
    value?: number;

    public static mapperFromPrtg (source: any): ServiceFlatNode
    {
        const target = new ServiceFlatNode();
        target.metaStatus = source.status.toLowerCase();
        target.status = source.status;
        target.codeStatus = source.codeStatus;
        target.flagStatus = parseInt(ServiceStatus[source.status], 10);
        target.isAcknowledged = source.isAcknowledged;
        target.serviceId = source.groupId;
        target.identifier = source.name;
        target.name = source.name;
        target.displayName = source.name;
        target.typeService = source.categoryName;
        target.hostName = source.hostName;
        target.hostAddress = source.hostAddress;
        target.lastValue = source.outputText;

        return target;
    }
}
